import {BaseService} from './Core/BaseService';
import {BaseCachedService} from './Core/BaseCachedService';
import {OrganizationNameTableColumn} from "../Components/Pages/Organizations/OrganizationNameTableColumn";
// import {Organization} from "../Models/StreamBank/Organization";

class OrganizationService extends BaseCachedService {
    get Url() { return super.Url + this.PageUrl; }
    get ModelName() { return "Organization"; }
    get PrimaryKeyProperty() { return "organizationId"; }
    get TitleProperty() { return "name"; }

    get PageUrl() { return "/organizations"; }
    
    get ItemNamePlural() { return "organizations"; }
    get CreatePermission() { return "create_organization"; }
    get UpdatePermission() { return "update_organization"; }
    
    GetOrganizations() {
        return this.Get();
    }

    GetModel(organizationId) {
        return this.SendRequest(BaseService.GET, organizationId);
    }

    UpdateModel(organization) {
        this.FlushCache();
        return this.SendRequest(BaseService.PUT, organization);
    }

    CreateModel(organization) {
        this.FlushCache();
        return this.SendRequest(BaseService.POST, organization);
    }

    DeleteModel(organizationId) {
        this.FlushCache();
        return this.SendRequest(BaseService.DELETE, organizationId);
    }
    
    get TableColumns() {
        return [
            {
                title: "Name",
                key: this.TitleProperty,
                sortable: true,
                logic: (x) => x[this.TitleProperty] ?? 'N/A',
                renderer: OrganizationNameTableColumn
            },
        ]
    }
}

export const service = new OrganizationService();
